<script setup lang="ts">
import { cn } from '@pokerly/ui';
</script>

<template>
    <div
        :class="
            cn(
                'p-4',
                'flex',
                'justify-center',
                '[&_svg]:size-8',
                'text-foreground-subtle-alt',
                'group-hover/voting-option:text-foreground-brand',
                'group-hover/voting-option:[&_svg]:text-foreground-brand',
                'group-data-[active=true]/voting-option:text-foreground-brand',
                'group-data-[active=true]/voting-option:[&_svg]:text-foreground-brand',
            )
        "
    >
        <slot></slot>
    </div>
</template>

<style scoped></style>
